import "./jquery"
// import "jquery-ui/jquery-ui"
// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import Trix from "trix"
import * as bootstrap from "bootstrap"
//app/javascript/application.js
import "./jquery"

Object.assign(Trix.config.lang, {
  bold: "Жирный", italic: "Курсив", strike: "Зачёркнутый", link: "Ссылка",
  heading1: "Заголовок", quote: "Цитата", code: "Код", bullets: "Маркированный список",
  numbers: "Нумерованный список", outdent: "Уменьшить отступ", indent: "Увеличить отступ",
  undo: "Отменить", redo: "Повторить", unlink: "Удалить ссылку", url: "Добавить ссылку",
  urlPlaceholder: "Введите адрес ссылки…"
})
